<script type="text/jsx" lang="jsx">
import addonBase from '@/views/config/addon-cards/templates/base.vue';
import mx_config from '@/plans/MASTER_CLASS/mixin';
import { ADDON_GROUP, planTypes } from '@/common/constants';
import { plansof } from '@/utils/chain';
import store from '@/store';
import _ from 'lodash';

export default {
  name: 'MasterClassAddon',
  mixins: [addonBase, mx_config],
  group: ADDON_GROUP.JOINT_SALES,
  for: () => {
    const getters = store.getters;
    const hasZoomMeeting = plansof(getters.getSelectedPlans).type(planTypes.ZOOM_MEETING).has();

    if (!getters.isFromPartnerRefer) return false;
    if (!hasZoomMeeting) return false;

    // promo current plan with masterclass
    const isPromoCurrentPlan = _.some(getters.planMapFlat, (p) => {
      return _.includes(getters.partnerRefer?.preloadPlan, p.plan_code) && p.externalProduct;
    });

    if (!isPromoCurrentPlan) return false;

    return true;
  },
  methods: {
    mx_fullPrice() {
      return <div class="opc-addon__subtitle">
        <span>{this.$money(this.singleOriginAmount, { forceDiff: true })}</span>
        <priceVATTip />
      </div>;
    },
    mx_discountPrice() {
      return <div class="opc-addon__subtitle">
        <span class="opc-addon__discount-price">{this.$money(this.afterSingleDiscountAmount, { forceDiff: true })}</span>
        <del class="opc-addon__origin-price">{this.$money(this.singleOriginAmount, { forceDiff: true })}</del>
        <priceVATTip />
      </div>;
    },
    mx_subTitle() {
      return this.singleDiscountAmount ? this.mx_discountPrice() : this.mx_fullPrice();
    },
  },
};
</script>

<style lang="scss">
.opc-addon {
  &__discount-price {
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%; /* 16.8px */
  }

  &__origin-price {
    color: #666487;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    margin-left: 4px;
  }
}
</style>
